// extracted by mini-css-extract-plugin
module.exports = {"shadow":"AppInfoItem_shadow__1L-He","appInfoItem":"AppInfoItem_appInfoItem__3tQLB","menuIcon":"AppInfoItem_menuIcon__1C2qM","modal":"AppInfoItem_modal__183Uh"};